import React from 'react'
import { HashRouter as Router, Switch } from 'react-router-dom'
import { Provider } from 'mobx-react'

import AppStore from '@/store'
import routeConfig from './route.config'
import { generateRoutes } from '@/utils/router'

function isPC() {
    const userAgentInfo = navigator.userAgent
    const Agents = ['Android', 'iPhone',
        'SymbianOS', 'Windows Phone',
        'iPad', 'iPod']
    let flag = true
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false
            break
        }
    }
    return flag
}

const h5Type = isPC()
if (!h5Type) {
    window.location = `${window.location.origin}/home-h5/home.html`
}

const App = () => (
    <Provider appStore={AppStore}>
        <Router>
            <Switch>{ generateRoutes(routeConfig) }</Switch>
        </Router>
    </Provider>
)

export default App
